<script>
  export default {
    name: 'accessory-list-item',
    props: ['item', 'category'],
    computed: {
      imagePath () {
        try {
          return require("@/assets/images/uploads/accessories/" + this.category.slug + "/" + this.item.slug + ".png")
        }
        catch (e) {
          console.log('imagePath: error, get placeholder')
          return require("@/assets/images/common/placeholder.png")
        }
      },
      getPricing() {
        if (this.item.pricing == null) {
          return '-'
        }
        return this.item.pricing.amount + " " + this.item.pricing.currencySymbol
      },
    }
  }
</script>
<template>
  <b-col
    md="6"
    class="mt-5">
    <b-card
      header-bg-variant="dark"
      header-text-variant="white"
      no-body>
      <template #header>
        <h5
          class="mb-0 uppercase">
          {{ item.name }}
        </h5>
      </template>
      <b-card-body>
        <b-card-img
          :src="imagePath">
        </b-card-img>
        <b-card-text
          class="description"
          >
          {{ item.shortDescription }}
        </b-card-text>
        <b-list-group
          flush
          class="mt-4">
          <b-list-group-item
            class="d-flex justify-content-between align-items-center">
            <span class="section-item">
              Prezzo
            </span>
            <b-badge variant="light" pill>
              {{ this.getPricing }}
            </b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-card-body>
    </b-card>
  </b-col>
</template>
<style scoped>
  .section-item {
    text-transform: uppercase;
  }
  .description {
    margin-top: 2em;
    line-height: 1em;
    min-height: 1.5em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
  .material {
    text-transform: uppercase;
  }
</style>